import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { clsx } from 'clsx';
import { getSidebarWrapper } from '../utils/commons';

const CLOSE_ICON = 'ri-arrow-up-s-line';
const OPEN_ICON = 'ri-arrow-down-s-line';

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  closeSiblings = () => {
    // This behavior changes during the course of time, passing to be able to open only one dropdown.
    // So this use of querySelector instead of states.
    const openNodes = document.querySelector('.is--open');

    if (openNodes) {
      openNodes.classList.remove('is--open');
    }
  };

  toggleDropdown = e => {
    const { expandSidebar } = this.props;
    const currentTarget = e.currentTarget;
    const openNode = currentTarget.nextElementSibling;
    const isOpen = openNode && openNode.classList.contains('is--open');
    const isCollapsed = getSidebarWrapper().classList.contains('collapsed');

    this.closeSiblings();

    if ((openNode && !isOpen) || isCollapsed) {
      openNode.classList.add('is--open');
    }

    expandSidebar();
  };

  getChevron = () => {
    return (
      <span className="chevron">
        <i className={clsx('open--icon', OPEN_ICON)} />
        <i className={clsx('close--icon', CLOSE_ICON)} />
      </span>
    );
  };

  checkIfOpen = () => {
    const { isActive } = this.props;

    // If the service is not active, the dropdown is always open
    return !isActive;
  };

  render() {
    const { id, title, icon, isOpen, children } = this.props;

    return (
      <li id={id} className={clsx('md__sidebar__item', { empty: this.checkIfOpen() })}>
        <button
          title={title}
          type="button"
          aria-expanded={this.checkIfOpen()}
          className={clsx('button__blank item__content', { text: this.checkIfOpen() })}
          onClick={this.toggleDropdown}
        >
          <span className={clsx('icon', { active: isOpen })}>{icon}</span>
          <span className="menu__text">{title}</span> {!this.checkIfOpen() && this.getChevron()}
        </button>
        <ul className={clsx('md__menu__subitems', { 'is--open': this.checkIfOpen() || isOpen })}>
          {children}
        </ul>
      </li>
    );
  }
}

Dropdown.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  expandSidebar: PropTypes.func.isRequired,
};

export default Dropdown;
